import { SpotList } from "Domain/Model/SpotList/SpotList";

export const FIND_SPOT_LIST_SUCCESS = 'FIND_SPOT_LIST_SUCCESS';

export const findSpotListSuccess = (spotList: Record<string, SpotList>) => ({
    type: FIND_SPOT_LIST_SUCCESS,
    payload: { spotList },
});
